import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import * as PaymentsActions from 'rebook/apps/payments/actions/PaymentsActions';
import * as UserActions from 'rebook/apps/users/actions/UserActions';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import BookRentPaymentStatus from 'rebook/apps/payments/components/BookRentPaymentStatus';
import BookRentHeader from 'rebook/apps/books/components/BookRentHeader';
import BookRentAppButtons from 'rebook/apps/books/components/BookRentAppButtons';

import styles from './style.scss';


class PaymentRentStatusView extends React.Component {
  constructor(props) {
    super(props);
    const paymentInfo = get(props, 'location.state.payments', null);
    this.timer = null;
    this.checkStatusInterval = 5 * 1000; // poll for payment status this every seconds
    this.state = {
      paymentInfo,
      bookDetail: null,
    };
  }

  componentDidMount() {
    const { paymentInfo } = this.state;
    if (!paymentInfo) {
      this.checkStatus();
    }
  }

  delayCheckStatus() {
    this.timer = setTimeout(() => this.checkStatus(), this.checkStatusInterval);
  }

  fetchBook(id) {
    const url = `/api/books/${id}/`;
    return async () => {
      await fetchQuery(url, { apiVersion: 4 })
        .then(({ data }) => {
          this.setState({ bookDetail: data });

          ga('send', 'event', {
            eventCategory: 'Payment',
            eventAction: 'BuyRent',
            eventLabel: data.name,
          });
          yaMetrikaReachGoal('BuyRent');
        })
        .catch(({ data, resp, error }) => {
          const status = get(resp, 'status', null);
          Raven.captureMessage('failed to load book detail due to server error', {
            level: 'error',
            extra: {
              status,
              response: data,
              error,
            },
          });
        });
    };
  }

  checkStatus() {
    const { paymentUuid } = this.props.match.params;

    fetchQuery(`/api/payments/${paymentUuid}/`)
      .then(
        ({ data }) => {
          if (data.status === 'accepted' || data.status === 'settled' || data.status === 'voided') {
            const bookId = get(data, 'rent_product.book');
            this.setState({ paymentInfo: data });
            this.fetchBook(bookId)();
          }
          else if (data.status === 'new' || data.status === 'pending') {
            // continue polling
            this.delayCheckStatus();
          }
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to check rent payment status due to server error', {
            level: 'error',
            extra: {
              paymentUuid: paymentUuid,
              status: resp ? resp.status : null,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { bookDetail } = this.state;
    const { user } = this.props;
    const isAudio = get(bookDetail, 'type', '') === 'audio';

    return (
      <div className={styles.paymentRentStatus}>
        {!bookDetail && <SpinnerLoader />}
        {bookDetail && (
          <React.Fragment>
            <BookRentHeader book={bookDetail} />
            <BookRentPaymentStatus book={bookDetail} user={user} />
            <BookRentAppButtons isAudio={isAudio} />
          </React.Fragment>
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    payments: state.payments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    UserActions: bindActionCreators(UserActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
    PaymentsActions: bindActionCreators(PaymentsActions, dispatch),
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRentStatusView);
